import { matchPath, useLocation } from "react-router-dom";

import ArroSrc from "assets/images/cobrands/arro.svg";
import BeemSrc from "assets/images/cobrands/beem.svg";
import BestMoneySrc from "assets/images/cobrands/best-money.svg";
import CappsoolSrc from "assets/images/cobrands/cappsool.png";
import LadderSrc from "assets/images/cobrands/ladder.svg";
import UnestSrc from "assets/images/cobrands/unest.svg";
import WyshLogo from "assets/logos/wyshbox_logo_lg.svg";
import { env } from "config";
import { useAppSelector } from "store";
import { getIsCoBrandedFlow, getIsCoBrandedJourney } from "store/selectors/getIsCoBrandedFlow";

export type CoBrandSlug =
  "arro" | "beem" | "best-money" | "cappsool" | "ladder" | "unest" | "wysh-test";

interface ICoBrandMetadata {
  logoSrc: string;
  name: string;
}

const isDevOrStaging = ["development", "testing", "staging"].includes(env);

export const CO_BRAND_SLUGS_BY_CAMPAIGN_ID: Record<string, CoBrandSlug> = {
  ...(isDevOrStaging ? { "TEST-CODE-001": "wysh-test" } : {}),
  5363833: "arro",
  34020: "best-money",
  1985270: "cappsool",
  1094301: "ladder",
  "1094301_ga": "ladder",
  "1094301_direct": "ladder",
  2235149: "unest",
  5654324: "beem",
};

export const CO_BRAND_METADATA_BY_SLUG: Partial<Record<CoBrandSlug, ICoBrandMetadata>> = {
  ...(isDevOrStaging ? { "wysh-test": { logoSrc: WyshLogo, name: "Test Partner" } } : {}),
  arro: { logoSrc: ArroSrc, name: "Arro" },
  beem: { logoSrc: BeemSrc, name: "Beem" },
  "best-money": { logoSrc: BestMoneySrc, name: "Best Money" },
  cappsool: { logoSrc: CappsoolSrc, name: "Best Life Insurance Hub" },
  ladder: { logoSrc: LadderSrc, name: "Ladder" },
  unest: { logoSrc: UnestSrc, name: "Unest" },
};

const CO_BRANDED_PATHS = [
  "/coverage-preview",
  "/flow/ineligibility-warning",
  "/getting-coverage",
  "/products/insurance/welcome",
  "/products/insurance/wysh-builder/list",
  "/wysh-builder/list",
];

export const useCoBranding = () => {
  const { pathname: currentPath } = useLocation();
  const utmCampaign = useAppSelector(state => state.analyticsTracker.utm.utm_campaign);
  const isCoBrandedFlowSelector = useAppSelector(getIsCoBrandedFlow);
  const isCoBrandedJourneySelector = useAppSelector(getIsCoBrandedJourney);

  const coBrandSlug = CO_BRAND_SLUGS_BY_CAMPAIGN_ID[utmCampaign];
  const coBrandMetadata = (coBrandSlug && CO_BRAND_METADATA_BY_SLUG[coBrandSlug]) || undefined;

  const isCoBrandedRoute = CO_BRANDED_PATHS.some(path =>
    matchPath({ path, end: true }, currentPath)
  );
  // The selectors only return whether the flow/step is co-branded; check the path here.
  const isCoBrandedFlow = isCoBrandedFlowSelector && currentPath === "/fulfillment";
  const isCoBrandedJourney = isCoBrandedJourneySelector && currentPath === "/fulfillment";
  const isOnboardingIntroFlow = isCoBrandedFlow || isCoBrandedJourney;

  return {
    coBrandMetadata,
    isCoBranded: !!coBrandMetadata && (isCoBrandedRoute || isOnboardingIntroFlow),
  };
};
